export default "__VITE_ASSET__BWXeX3TA__"